import { GTM_ID } from "@/constants";

/**
 * Pushes a GTM dataLayer event.
 * Without a container id the array is left unset so non-production builds stay quiet.
 */
export const pushDataLayerEvent = (eventData: {
  event: string;
  [key: string]: any;
}) => {
  if (typeof window === "undefined" || !GTM_ID) return;
  const layer = ((window as any).dataLayer = (window as any).dataLayer || []);
  layer.push(eventData);
};
